import { Steps } from './Steps';

export const Titles: {
  //TODO: use next type when estimation be added
  //[key in Steps]: string;
  [key in Steps]?: string;
} = {
  [Steps.Bookings]: 'Bookings',
  [Steps.YourVehicle]: 'Vehicle',
  [Steps.SelectService]: 'Service',
  [Steps.SelectDealer]: 'Dealer',
  // [Steps.EstimatedPrice]: 'Price',
  [Steps.Appointment]: 'Appointment',
  // [Steps.CollectionAndDelivery]: 'Collection',
  [Steps.ContactDetails]: 'Contact',
  [Steps.ReviewAndSubmit]: 'Review',
  [Steps.Identification]: 'Identification',
};
